<template>
  <div class="min-h-screen bg-[#121212] text-white">
    <AppHeader />

    <main class="container mx-auto px-4 pt-16 md:pt-24 pb-32 md:pb-12 mb-safe">
      <!-- Page Header -->
      <div class="flex items-center gap-4 mb-8">
        <button 
          @click="$router.back()" 
          class="w-10 h-10 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 transition-colors"
        >
          <i class="fas fa-arrow-left"></i>
        </button>
        <div>
          <h1 class="text-2xl md:text-3xl font-bold">My Franchise Codes</h1>
          <p class="text-white/60 text-sm mt-1">Manage and track all your generated subscription codes</p>
        </div>
      </div>

      <!-- Stats Summary -->
      <div v-if="codes.length" class="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
        <div class="bg-white/5 rounded-xl p-4 text-center">
          <p class="text-2xl font-bold text-white">{{ codes.length }}</p>
          <p class="text-white/60 text-sm">Total Codes</p>
        </div>
        <div class="bg-green-500/10 rounded-xl p-4 text-center">
          <p class="text-2xl font-bold text-green-500">{{ activeCodes }}</p>
          <p class="text-white/60 text-sm">Active</p>
        </div>
        <div class="bg-blue-500/10 rounded-xl p-4 text-center">
          <p class="text-2xl font-bold text-blue-500">{{ usedCodes }}</p>
          <p class="text-white/60 text-sm">Used</p>
        </div>
        <div class="bg-red-500/10 rounded-xl p-4 text-center">
          <p class="text-2xl font-bold text-red-500">{{ expiredCodes }}</p>
          <p class="text-white/60 text-sm">Expired</p>
        </div>
      </div>

      <!-- Franchise Codes Component -->
      <FranchiseCodes />
    </main>
  </div>
</template>

<script>
import AppHeader from '../components/Header.vue'
import FranchiseCodes from '../components/FranchiseCodes.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'FranchiseCodesPage',
  components: {
    AppHeader,
    FranchiseCodes
  },
  data() {
    return {
      codes: [],
      isLoading: false
    }
  },
  computed: {
    ...mapGetters(['currentUser']),
    user() {
      return this.currentUser
    },
    activeCodes() {
      return this.codes.filter(c => c.status === 'ACTIVE').length
    },
    usedCodes() {
      return this.codes.filter(c => c.status === 'USED').length
    },
    expiredCodes() {
      return this.codes.filter(c => c.status === 'EXPIRED').length
    }
  },
  async created() {
    if (!this.user) {
      await this.$store.dispatch('initializeStore')
    }
    if (!this.user) {
      this.$router.push('/')
      return
    }
    // Check if user is franchise
    if (!this.user.is_franchise) {
      this.$router.push('/profile')
      return
    }
    this.fetchCodes()
  },
  methods: {
    async fetchCodes() {
      this.isLoading = true
      try {
        const { franchiseAPI } = await import('../utils/api')
        const response = await franchiseAPI.getCodes()
        this.codes = response.data
      } catch (err) {
        console.error('Failed to fetch codes:', err)
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>

<style scoped>
.mb-safe {
  margin-bottom: env(safe-area-inset-bottom, 0px);
}

@media (max-width: 768px) {
  .pb-32 {
    padding-bottom: calc(8rem + env(safe-area-inset-bottom, 0px));
  }
}
</style>
